<template>
    <BaseWidget :title="$tc('messages.battles', 2)">
        <div class="divide-y-2 divide-gray-100">
            <div class="flex justify-between py-2" v-for="battle in widget.content.battles" :key="battle.id">
                <div>
                    <img :src="battle.enemy_image" alt="" class="h-12 inline-block" />
                    {{ battle.name }}
                </div>
                <div :title="$t('messages.help_defeat_the_enemy')">
                    <InertiaSquareLinkButton action="quiz" :href="battle.links.show" />
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';

export default {
    name: 'BattlesWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        InertiaSquareLinkButton,
    },
};
</script>
